import React from 'react'
import BookList from '../components/Book/BookList'

function BookListView() {
  return (
    <BookList />
  )
}

export default BookListView